import type { InboundRow } from './types'

/**
 * Minutes that decide whether a truck stays on the "Arriving soon" strip.
 *
 * A measured slice time wins, because that is the arrival. Until the road ahead
 * has been driven, measured_eta_min is null and the strip keeps the window it
 * already had (eta_min): the truck's recent speed, else 40 km/h, never below 10.
 * The printed cell does not use that fallback. A missing measurement leaves a
 * dash, and the truck stays.
 */
export function arrivalStripMinutes(row: InboundRow): number | null {
  return row.measured_eta_min != null ? row.measured_eta_min : row.eta_min
}

export function onArrivalStrip(row: InboundRow, withinMin = 30): boolean {
  const minutes = arrivalStripMinutes(row)
  return minutes != null && minutes <= withinMin
}
